import { render, staticRenderFns } from "./DefaultCardMetricList.vue?vue&type=template&id=bfc146da&scoped=true&"
import script from "./DefaultCardMetricList.vue?vue&type=script&lang=js&"
export * from "./DefaultCardMetricList.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCardMetricList.vue?vue&type=style&index=0&id=bfc146da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc146da",
  null
  
)

export default component.exports